import { ref, onMounted, onUnmounted } from 'vue';

export function useScreenSize() {
  const isMobile = ref(false);
  const isTablet = ref(false);

  const checkIfMobile = () => {
    if (window.innerWidth <= 768) {
      isMobile.value = true;
      isTablet.value = false;
    } else if (window.innerWidth > 768 && window.innerWidth <= 1024) {
      isMobile.value = false;
      isTablet.value = true;
    } else {
      isMobile.value = false;
      isTablet.value = false;
    }
    console.log("screen size",  window.innerWidth);
  };

  onMounted(() => {
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', checkIfMobile);
  });

  return {
    isMobile,
    isTablet,
  };
}
